// Function 1: Button selection
document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".button-select");

  buttons.forEach((button) => {
    const checkbox = button.querySelector('input[type="checkbox"]');
    const span = button.querySelector("span");

    if (checkbox && span) {
      checkbox.addEventListener("change", function () {
        if (this.checked) {
          span.classList.add("checked");
        } else {
          span.classList.remove("checked");
        }
      });
    }
  });
});

// Function 2: Keyword selection and search
document.addEventListener("DOMContentLoaded", function () {
  const searchInput = document.getElementById("keyword-search");
  const keywordButtons = document.getElementById("keyword-buttons");
  const selectedKeywordsContainer =
    document.getElementById("selected-keywords");

  // for selecting keywords in topic creation modal
  const topicTagInput = document.querySelector("#bbp_topic_tags");

  if (!searchInput || !keywordButtons || !selectedKeywordsContainer) {
  }

  const MAX_KEYWORDS = 3;

  function createSelectedKeywordElement(keyword) {
    const span = document.createElement("span");
    span.className = "selected-keyword";
    span.dataset.keyword = keyword;
    span.innerHTML = `
      <span class="keyword-text">${keyword}</span>
      <button type="button" class="remove-keyword">&times;</button>
    `;
    return span;
  }

  function updateKeywordVisibility() {
    const searchTerm = searchInput.value.toLowerCase();
    Array.from(keywordButtons.children).forEach((label) => {
      const keyword = label.textContent.trim().toLowerCase();
      const checkbox = label.querySelector('input[type="checkbox"]');
      if (checkbox && (checkbox.checked || !keyword.includes(searchTerm))) {
        label.style.display = "none";
      } else {
        label.style.display = "";
      }
    });
  }

  function toggleKeyword(keyword, isSelected) {
    const selectedKeywords =
      selectedKeywordsContainer.querySelectorAll(".selected-keyword");

    if (isSelected && selectedKeywords.length >= MAX_KEYWORDS) {
      return false;
    }

    if (isSelected) {
      const selectedElement = createSelectedKeywordElement(keyword);
      selectedKeywordsContainer.appendChild(selectedElement);
      const label = keywordButtons
        .querySelector(`input[value="${keyword}"]`)
        ?.closest("label");
      if (label) label.style.display = "none";
    } else {
      selectedKeywordsContainer
        .querySelector(`span[data-keyword="${keyword}"]`)
        ?.remove();
      const label = keywordButtons
        .querySelector(`input[value="${keyword}"]`)
        ?.closest("label");
      if (label) label.style.display = "";
    }

    updateKeywordVisibility();
    return true;
  }

  const makeKeywordArray = () => {
    if (topicTagInput) {
      const selectedKeywords = document.querySelectorAll(".selected-keyword");
      let keywordsArray = [];

      selectedKeywords.forEach((keyword) => {
        keywordsArray = [...keywordsArray, keyword.dataset.keyword];
      });

      topicTagInput.value = keywordsArray.toString();
    }
  };

  keywordButtons?.addEventListener("change", function (event) {
    if (event.target.type === "checkbox") {
      const success = toggleKeyword(event.target.value, event.target.checked);
      if (!success) {
        event.target.checked = false;
      }
      makeKeywordArray();
    }
  });

  selectedKeywordsContainer?.addEventListener("click", function (event) {
    if (event.target.classList.contains("remove-keyword")) {
      const keywordElement = event.target.closest(".selected-keyword");
      if (keywordElement) {
        const keyword = keywordElement.dataset.keyword;
        const checkbox = keywordButtons.querySelector(
          `input[value="${keyword}"]`
        );
        if (checkbox) {
          checkbox.checked = false;
          toggleKeyword(keyword, false);
        }

        makeKeywordArray();
      }
    }
  });

  searchInput?.addEventListener("input", updateKeywordVisibility);

  // Initial setup
  if (keywordButtons) {
    Array.from(
      keywordButtons?.querySelectorAll('input[type="checkbox"]:checked')
    ).forEach((checkbox) => {
      toggleKeyword(checkbox.value, true);
    });
  }
});

// Function 3: Progress bar update
document.addEventListener("DOMContentLoaded", function () {
  const progress = document.querySelector("#progress");
  const prev = document.querySelector("#prev");
  const next = document.querySelector("#next");
  const circles = document.querySelectorAll(".circle");
  const slides = document.querySelectorAll(".slide");

  if (
    !progress ||
    !prev ||
    !next ||
    circles.length === 0 ||
    slides.length === 0
  ) {
    return;
  }

  let currActive = 1;

  function update() {
    circles.forEach(function (circle, i) {
      if (i < currActive) {
        circle.classList.add("active");
      } else {
        circle.classList.remove("active");
      }
    });

    slides.forEach(function (slide, i) {
      if (i + 1 === currActive) {
        slide.classList.add("active-slide");
      } else {
        slide.classList.remove("active-slide");
      }
    });

    const actives = document.querySelectorAll(".circle.active");
    const width = ((actives.length - 1) / (circles.length - 1)) * 100;
    progress.style.width = width + "%";

    if (currActive === 1) {
      prev.disabled = true;
    } else if (currActive === circles.length) {
      next.disabled = true;
    } else {
      prev.disabled = false;
      next.disabled = false;
    }
  }

  function goToSlide(slideNumber) {
    currActive = slideNumber;
    if (currActive < 1) currActive = 1;
    if (currActive > circles.length) currActive = circles.length;
    update();
  }

  next.addEventListener("click", function () {
    goToSlide(currActive + 1);
  });

  prev.addEventListener("click", function () {
    goToSlide(currActive - 1);
  });

  circles.forEach(function (circle, index) {
    circle.addEventListener("click", function () {
      goToSlide(index + 1);
    });
  });

  update();
});

// Function 4: Profile picture preview
// Function: Avatar preview
document.addEventListener("DOMContentLoaded", function () {
  const fileInput = document.getElementById("avatar");
  const previewImg = document.getElementById("profile-picture-preview-img");
  const fileNameSpan = document.querySelector(".file-name");

  if (!fileInput || !previewImg) {
    console.log("One or more required elements are missing.");
    return;
  }

  fileInput.addEventListener("change", function (e) {
    const file = e.target.files[0];
    if (file) {
      // Create a FileReader to read the image file
      const reader = new FileReader();
      reader.onload = function (e) {
        // Set the preview image source
        previewImg.src = e.target.result;
      };
      reader.readAsDataURL(file);

      // Update the file name display
      fileNameSpan.textContent = file.name;

      // Log the file details (optional, for debugging)
      console.log("File selected:", file.name, "Size:", file.size, "bytes");
    } else {
      // Reset to default image if no file is selected
      previewImg.src = defaultImageUrl; // Make sure to define this variable with your default image URL
      fileNameSpan.textContent = "";
    }
  });
});

// Function 5: Description Counter
document.addEventListener("DOMContentLoaded", function () {
  var textarea = document.querySelector('textarea[name="user_bio"]');
  var charCount = document.getElementById("char-count");

  function updateCharCount() {
    charCount.textContent = textarea.value.length;
  }

  if (textarea) {
    textarea.addEventListener("input", updateCharCount);
    updateCharCount(); // Initial count
  }
});
